import { api } from 'common/frontend/api';
import { BatchManager } from 'common/frontend/firebase/firestore';

export const publishManyProducts = async (ids: string[]) => {
	const batchManager = new BatchManager();

	ids.forEach((id) => {
		api(batchManager.batch()).products.doc(id).update({
			additionalProduct: false,
		});
	});

	await batchManager.commit();
};

export const unpublishManyProducts = async (ids: string[]) => {
	const batchManager = new BatchManager();

	ids.forEach((id) => {
		api(batchManager.batch()).products.doc(id).update({
			additionalProduct: true,
		});
	});

	await batchManager.commit();
};
